import { useCallback } from 'react'

import { Optins, Form, FieldSettings } from '@ana/shared'
import { CardContent } from '@mui/material'

import SummaryAllergies from '../Allergies'
import SummaryGeneralInformation from '../GeneralInformation'
import SummaryMedication from '../Medication/Medication'
import { SummaryOptins } from '../Optins/Optins'
import SummaryPreConditions from '../PreConditions'
import SummaryWishes from '../Wishes'

import * as S from './Content.styles'

type Props = {
  initialValues?: Partial<Form>
  optins?: Optins
  shouldShowCancellationNotice?: boolean
}

const Content = ({ optins, initialValues = {}, shouldShowCancellationNotice = true }: Props) => {
  const getEditableFieldProps = useCallback(
    (settings: FieldSettings) => {
      const value = initialValues[settings.name as keyof Form]

      return {
        label: settings.label.replace('field.', 'summary.'),
        value: Array.isArray(value)
          ? value.map((v) => (typeof v === 'object' ? JSON.stringify(v) : v)).join(', ')
          : value,
        isRequired: settings.isRequired as boolean,
      }
    },
    [initialValues]
  )

  return (
    <S.Root>
      <CardContent>
        <S.GridContainer container spacing={3}>
          <SummaryGeneralInformation getEditableFieldProps={getEditableFieldProps} />

          <SummaryPreConditions values={initialValues} />

          <SummaryMedication values={initialValues} />

          <SummaryAllergies values={initialValues} getEditableFieldProps={getEditableFieldProps} />

          <SummaryWishes values={initialValues} getEditableFieldProps={getEditableFieldProps} />

          <SummaryOptins
            getEditableFieldProps={getEditableFieldProps}
            optins={optins}
            shouldShowCancellationNotice={shouldShowCancellationNotice}
          />
        </S.GridContainer>
      </CardContent>
    </S.Root>
  )
}

export default Content
